export default __webpack_public_path__ + "static/media/one-star.0c2a8d5d.png";